import * as XLSX from "xlsx";
import * as dataToTransaction from "./transaction-util";

import { FileLoaded } from "../data-types";
import { Transaction } from "../data-types";

const getDataFromExcel = (file: any) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = (e: any) => {
      try {
        const bstr = e.target?.result;
        const wb = XLSX.read(bstr, { type: "binary" });
        const wsname = wb.SheetNames[0];
        const ws = wb.Sheets[wsname];
        const rawData = XLSX.utils.sheet_to_json(ws, { header: 1 });
        resolve(rawData);
      } catch (err) {
        reject(err);
      }
    };
    reader.readAsArrayBuffer(file);
  });
};

const chooseBank = (
  bank: string,
  rawData: object[],
  fileLoaded: FileLoaded
) => {
  if (bank === "Amex") {
    return dataToTransaction.amex(rawData, fileLoaded);
  } else if (bank === "Chase") {
    return dataToTransaction.chase(rawData, fileLoaded);
  } else if (bank === "Discover") {
    return dataToTransaction.discover(rawData, fileLoaded);
  }
  return null;
};

const validateTransaction = (transaction: Transaction[]) => {
  transaction.forEach((element) => {
    const isValid =
      !isNaN(Number(element.amount)) &&
      element.fullDate instanceof Date &&
      typeof element.category === "string" &&
      typeof element.BCJL === "string" &&
      typeof element.bank === "string" &&
      typeof element.desc === "string";
    if (!isValid) {
      return false;
    }
  });
  return true;
};

export { getDataFromExcel, chooseBank, validateTransaction };
